export class FactorySimpleModel {
    name: string;
    nombre?: string;
    uuid: string;
    selected: boolean;
}
